export const LetterType = Object.freeze({
    REPLIED: "REPLIED",
    SENT: "SENT",
});
